import React, { useEffect, useState } from "react";
import "./dashboard.css";
import { useNavigate } from "react-router-dom";
import {
  convertSecondsToHoursInner,
  convertSecondsToHoursInnerHoursOnly,
  convertSecondsToHoursInnerMinutesOnly,
  convertSecondsToHoursInnerSecondsOnly,
  convertSecondsToHoursLive,
  convertText,
  getLocalUserDataByKey,
  logMessage,
} from "../../utils/helpers.js";
import { BiImport, BiSort } from "react-icons/bi";
import { LuRadar } from "react-icons/lu";
import { FaRegCirclePlay, FaRegCirclePause } from "react-icons/fa6";
import { PiMagnifyingGlassLight } from "react-icons/pi";
import Header from "../../components/common/header.js";
import imagePaths from "../../assets/imagePaths.js";
import paths from "../../utils/constants.js";
import api from "../../api/api.js";
import { ApiResponse } from "../../models/ApiResponseModel.js";
import { DataModel } from "../../models/projectModel.js";
import { convertSecondsToHours } from "../../utils/helpers.js";
import {
  AiOutlineClose,
  AiOutlineSortAscending,
  AiOutlineSortDescending,
} from "react-icons/ai";
import { MdOutlineCancel } from "react-icons/md";
import {
  importDataModel,
  importedProjectModel,
} from "../../models/importedProjectModel.js";
import { Bars } from "react-loader-spinner";

const ProjectScreen = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [type, setType] = useState("completed");
  const [internalLoading, setInternalLoading] = useState(false);
  const [liveTimer, setLiveTimer] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [showWarningStartTimer, setShowWarningStartTimer] = useState(false);
  const [projectWarningId, setProjectWarningId] = useState("");
  const [showPlansPopup, setShowPlansPopup] = useState(false);
  const [showSortPopup, setSortShowPopup] = useState(false);
  const [showImportPopUp, setShowImportPopUp] = useState(false);
  const [updateProjectId, setUpdatedId] = useState("");
  const [page, setPage] = useState(1);
  const [search, setSearchKey] = useState("");
  const [searchDreamer, setSearchDreamer] = useState("");
  const [projectData, setProjectData] = useState(new DataModel({}));
  const [importedProjectDataMain, setImportedProjectData] = useState(
    new importDataModel({})
  );
  const [importProjectsFetched, setImportedProductsFetched] = useState(false);
  const [filteredDreamerData, setFilteredDreamerData] = useState([]);
  const [showUI, setShowUI] = useState(false);
  const [noUItext, setNoUiText] = useState("");
  const canUseShopify = getLocalUserDataByKey("canUseShopify");
  const [sortTypeKey, setSortTypeKey] = useState("");
  const [sortPattern, setSortPattern] = useState("");
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [sortType, setSortType] = useState("");
  const [importLoading, setImportLoading] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    type: "",
    sort: "",
    diamondType: "",
  });
  const [diamondTypeSort, setDiamondTypeSort] = useState("");

  const handleSortButtons = (pattern, type) => {
    setSortPattern(pattern);
    setSortType(type);
    if (type == "updated_time") {
      setSortTypeKey("Date Modified");
    } else {
      setSortTypeKey(type);
    }
  };

  const importProjects = async () => {
    if (selectedProjects.length === 0) {
      logMessage("Please select at least one project to import.", "alert");
      setShowImportPopUp(false);
      return;
    }

    try {
      setImportLoading(true);
      const data = {
        productData: JSON.stringify(selectedProjects),
      };
      const response = await api.importShopifyProducts(data);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        logMessage(apiResponse.message, "alert");
        // optionally clear selections
        setSelectedProjects([]);
        setSelectAllChecked(false);
        setType("completed");
        setImportedProductsFetched(false);
      } else {
        alert(response?.message || "Something went wrong while importing.");
      }
    } catch (error) {
      console.error("❌ Import error:", error);
      logMessage("An error occurred during import.", "alert");
      return;
    } finally {
      setImportLoading(false);
      setShowImportPopUp(false);
    }
  };

  const handleSort = async () => {
    toggleSortPopup();
    logMessage("sortPattern" + sortPattern);
    const sortData = {
      type: sortPattern,
      diamondType: diamondTypeSort,
      sort: sortType,
    };
    setSelectedFilters(sortData);
    await fetchProjectsNew(sortData);
    // await searchProducts();
  };
  const clearFilter = async (type) => {
    if (type == "diamondType") {
      const updatedFilters = {
        ...selectedFilters,
        diamondType: "",
      };

      // await setSelectedFilters((prevFilters) => ({
      //   ...prevFilters,
      //   diamondType: "",
      // }));
      setSelectedFilters(updatedFilters);

      setDiamondTypeSort("");
      await fetchProjectsNew(updatedFilters);
    } else {
      const updatedFilters = {
        ...selectedFilters,
        sort: "",
      };

      // await setSelectedFilters((prevFilters) => ({
      //   ...prevFilters,
      //   sort: "",
      // }));
      setSelectedFilters(updatedFilters);
      setSortPattern("");
      setSortType("");
      setSortTypeKey("");
      await fetchProjectsNew(updatedFilters);
    }
  };
  const handleDiamondType = (type) => {
    setDiamondTypeSort(type);
  };
  const handleTypeClick = async (type) => {
    setNoUiText("");
    setType(type);
  };
  const addProject = async () => {
    try {
      startLoading();
      const response = await api.verifyAddProject();
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        navigate(paths.ADD_PROJECT);
        stopLoading();
      } else if (apiResponse.status === 5) {
        setShowPlansPopup(true);
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    logMessage(liveTimer);
    if (liveTimer !== 0) {
      const intervalId = setInterval(() => {
        setLiveTimer(liveTimer + 1);
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [liveTimer]);

  const handleStartTimer = async (type, project_id) => {
    // console.log(projectData);
    const isTimerRunning = projectData.projects.some(
      (entry) => entry.timer_status === "started"
    );
    if (isTimerRunning) {
      setProjectWarningId(project_id);
      setShowWarningStartTimer(true);
      return;
    } else {
      handleTimer("start", project_id);
    }
  };

  const handleTimer = async (type, project_id) => {
    if (type == "stop") {
      stop_timer(project_id);
    } else {
      start_timer(project_id);
    }
    logMessage("handle timer clicked");
  };

  const start_timer = async (project_id) => {
    try {
      startLoading();
      const data = {
        project_id: project_id,
      };
      const response = await api.startTimer(data);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        setNoUiText("");
        await fetchProjects();
        await stopLoading();
        setShowUI(true);
        if (type == "completed") {
          setNoUiText("Currently, you don't have any completed projects.");
        } else if (type == "ongoing") {
          setNoUiText("Currently, you don't have any projects in progress.");
        } else {
          setNoUiText("Currently, you don't have any projects started.");
        }
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      await stopLoading();
      setShowUI(true);
      if (type == "completed") {
        setNoUiText("Currently, you don't have any completed projects.");
      } else if (type == "ongoing") {
        setNoUiText("Currently, you don't have any projects in progress.");
      } else {
        setNoUiText("Currently, you don't have any projects started.");
      }
    }
  };
  const stop_timer = async (project_id) => {
    try {
      startLoading();
      const data = {
        project_id: project_id,
      };
      const response = await api.stopTimer(data);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        setNoUiText("");
        await fetchProjects();
        await stopLoading();
        setShowUI(true);
        if (type == "completed") {
          setNoUiText("Currently, you don't have any completed projects.");
        } else if (type == "ongoing") {
          setNoUiText("Currently, you don't have any projects in progress.");
        } else {
          setNoUiText("Currently, you don't have any projects started.");
        }
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      await stopLoading();
      setShowUI(true);
      if (type == "completed") {
        setNoUiText("Currently, you don't have any completed projects.");
      } else if (type == "ongoing") {
        setNoUiText("Currently, you don't have any projects in progress.");
      } else {
        setNoUiText("Currently, you don't have any projects started.");
      }
    }
  };

  const openProjectDetail = (project_id) => {
    navigate(paths.PROJECT_DETAIL + "?project_id=" + project_id);
  };
  const handleChange = (e) => {
    setSearchKey(e.target.value);
  };
  const handleDreamerChange = (e) => {
    setSearchDreamer(e.target.value);
  };
  useEffect(() => {
    if (importedProjectDataMain.data?.length > 0) {
      setFilteredDreamerData(importedProjectDataMain.data);
    }
  }, [importedProjectDataMain]);

  const searchDreamerProducts = () => {
    const searchTerm = searchDreamer.trim().toLowerCase();

    if (!searchTerm) {
      // If empty search, show all original data
      setFilteredDreamerData(importedProjectDataMain.data);
      return;
    }

    const filtered = importedProjectDataMain.data.filter((project) => {
      const design = project.design?.toLowerCase() || "";
      const brand = project.brand?.toLowerCase() || "";
      return design.includes(searchTerm) || brand.includes(searchTerm);
    });

    setFilteredDreamerData(filtered);
  };

  const searchProducts = async () => {
    navigate(paths.SEARCH);
    // if (search !== "") {
    //   navigate(paths.SEARCH + "?search=" + search);
    // }
  };

  // useEffect(() => {
  //   const hasFilters = Object.values(selectedFilters).some(
  //     (value) => value !== ""
  //   );
  //   if (hasFilters) {
  //     startLoading();
  //     const timer = setTimeout(async () => {
  //       await fetchProjects();
  //       logMessage("runs second time");
  //       stopLoading();
  //     }, 1000); // 1000 milliseconds delay

  //     return () => clearTimeout(timer);
  //   }
  // }, [selectedFilters]);

  const updateProjectStatus = async () => {
    try {
      startLoading();
      const data = {
        project_id: updateProjectId,
      };
      const response = await api.updateProjectStatus(data);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        togglePopup();
        fetchProjects();
        await stopLoading();
        setShowUI(true);
        if (type == "completed") {
          setNoUiText("Currently, you don't have any completed projects.");
        } else if (type == "ongoing") {
          setNoUiText("Currently, you don't have any projects in progress.");
        } else {
          setNoUiText("Currently, you don't have any projects started.");
        }
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      await stopLoading();
      setShowUI(true);
      if (type == "completed") {
        setNoUiText("Currently, you don't have any completed projects.");
      } else if (type == "ongoing") {
        setNoUiText("Currently, you don't have any projects in progress.");
      } else {
        setNoUiText("Currently, you don't have any projects started.");
      }
    }
  };

  const handleUpdateStatus = async (id, status) => {
    if (status == "ongoing") {
      logMessage(id);
      logMessage("handle update status clciked");
      setUpdatedId(id);
      togglePopup();
    }
  };
  const navigateToPlans = async () => {
    navigate(`${paths.MY_PROFILE}?viewplan=true`);
  };

  const selectAllImported = (e) => {
    const isChecked = e.target.checked;
    setSelectAllChecked(isChecked);

    if (isChecked) {
      const selected = filteredDreamerData.map((project) => ({
        product_id: project.product_id,
        variant_id: project.variant_id,
      }));
      setSelectedProjects(selected);
    } else {
      setSelectedProjects([]);
    }
  };

  const selectProjectForImport = (e, project) => {
    const isChecked = e.target.checked;

    const item = {
      product_id: project.product_id,
      variant_id: project.variant_id,
    };

    if (isChecked) {
      setSelectedProjects((prev) => [...prev, item]);
    } else {
      setSelectedProjects((prev) =>
        prev.filter(
          (p) =>
            p.product_id !== item.product_id || p.variant_id !== item.variant_id
        )
      );
      setSelectAllChecked(false); // uncheck "select all" if any individual is unchecked
    }
  };

  const fetchProjectsNew = async (updatedFilters) => {
    setNoUiText("");
    setProjectData(new DataModel({}));
    try {
      startLoading();
      const data = {
        type: type,
        page: page,
        limit: 100000,
        sort: updatedFilters.sort,
        sortType: updatedFilters.type,
        diamondType: updatedFilters.diamondType,
      };
      const response = await api.getProjectList(data);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        // logMessage(response.data);
        const projectData = new DataModel(response.data);
        setProjectData(projectData);
        await stopLoading();
        setShowUI(true);
        if (type == "completed") {
          setNoUiText("Currently, you don't have any completed projects.");
        } else if (type == "ongoing") {
          setNoUiText("Currently, you don't have any projects in progress.");
        } else {
          setNoUiText("Currently, you don't have any projects started.");
        }
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      await stopLoading();
      setShowUI(true);
      if (type == "completed") {
        setNoUiText("Currently, you don't have any completed projects.");
      } else if (type == "ongoing") {
        setNoUiText("Currently, you don't have any projects in progress.");
      } else {
        setNoUiText("Currently, you don't have any projects started.");
      }
    }
  };
  const fetchProjects = async () => {
    setNoUiText("");
    setProjectData(new DataModel({}));
    try {
      startLoading();
      const data = {
        type: type,
        page: page,
        limit: 100000,
        sort: selectedFilters.sort,
        sortType: selectedFilters.type,
        diamondType: selectedFilters.diamondType,
      };
      const response = await api.getProjectList(data);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        // logMessage(response.data);
        const projectData = new DataModel(response.data);
        setProjectData(projectData);
        await stopLoading();
        setShowUI(true);
        if (type == "completed") {
          setNoUiText("Currently, you don't have any completed projects.");
        } else if (type == "ongoing") {
          setNoUiText("Currently, you don't have any projects in progress.");
        } else {
          setNoUiText("Currently, you don't have any projects started.");
        }
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      await stopLoading();
      setShowUI(true);
      if (type == "completed") {
        setNoUiText("Currently, you don't have any completed projects.");
      } else if (type == "ongoing") {
        setNoUiText("Currently, you don't have any projects in progress.");
      } else {
        setNoUiText("Currently, you don't have any projects started.");
      }
    }
  };
  const fetchImportProjects = async () => {
    try {
      setInternalLoading(true);
      const response = await api.getUsersOrders();
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        // logMessage(response.data);
        const importedProjectData = new importDataModel(response);
        console.log(importedProjectData);
        setImportedProjectData(importedProjectData);
        setInternalLoading(false);
        setImportedProductsFetched(true);
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      setInternalLoading(false);
    }
  };
  const togglePopup = () => {
    logMessage("toggleclicked");
    setShowPopup(!showPopup);
    logMessage(showPopup);
  };

  const toggleSortPopup = () => {
    logMessage("togglesortclicked");
    setSortShowPopup(!showSortPopup);
  };
  const toggleImportPopup = async () => {
    console.log("called popup");
    setShowImportPopUp(!showImportPopUp);
    if (importProjectsFetched === false) {
      await fetchImportProjects();
    }
  };
  useEffect(() => {
    if (type !== "") {
      logMessage("runs first time");
      fetchProjects();
    }
  }, [type]);
  return (
    <div className="full_page_inner">
      <Header />
      <div
        className="dashboard_container"
        style={{ backgroundImage: `url(${imagePaths.dashboard_background})` }}
      >
        <div className="home_container">
          {showWarningStartTimer && (
            <div className="popup-overlay">
              <div className="popup planspopup">
                <div
                  style={{
                    borderRadius: "8px",
                    backgroundImage: `url(${imagePaths.viewplans})`,
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{
                      width: "32px",
                      height: "32px",
                      marginRight: "8px",
                    }}
                    className="premium_icon_inside"
                    src={imagePaths.premium}
                  />

                  <p>Warning</p>
                  <p
                    style={{
                      paddingTop: "5px",
                      marginLeft: "15px",
                      cursor: "pointer",
                    }}
                  >
                    <MdOutlineCancel
                      style={{ width: "20px", height: "20px" }}
                      onClick={() => {
                        setShowWarningStartTimer(false);
                      }}
                    />
                  </p>
                </div>
                {/* <div className="redBackPlan">
                  <p>
                  Unable to add more than 5 project?
                  </p>
                  </div> */}
                <p style={{ padding: "2px", fontSize: "14px" }}>
                  Another timer is already running and will be paused if you
                  start a new timer
                </p>

                <button
                  className="delete-button viewplans-button"
                  onClick={() => {
                    handleTimer("start", projectWarningId);
                    setShowWarningStartTimer(false);
                  }}
                >
                  Confirm
                </button>
                <button
                  style={{ marginTop: "1px", marginBottom: "3px" }}
                  className="cancel-button canceldelacc"
                  onClick={() => setShowWarningStartTimer(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}

          {showPlansPopup && (
            <div className="popup-overlay">
              <div className="popup planspopup">
                <div
                  style={{
                    borderRadius: "8px",
                    backgroundImage: `url(${imagePaths.viewplans})`,
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{
                      width: "32px",
                      height: "32px",
                      marginRight: "8px",
                    }}
                    className="premium_icon_inside"
                    src={imagePaths.premium}
                  />

                  <p>Subscribe to premium</p>
                  <p
                    style={{
                      paddingTop: "5px",
                      marginLeft: "15px",
                      cursor: "pointer",
                    }}
                  >
                    <MdOutlineCancel
                      style={{ width: "20px", height: "20px" }}
                      onClick={() => setShowPlansPopup(false)}
                    />
                  </p>
                </div>
                <div className="redBackPlan">
                  <p>Unable to add more than 5 project?</p>
                </div>
                <p style={{ margin: 0, fontSize: "14px" }}>
                  Subscribe to premium and add unlimited projects.
                </p>

                <button
                  className="delete-button viewplans-button"
                  onClick={navigateToPlans}
                >
                  Upgrade to Premium
                </button>
                {/* <button
                  className="cancel-button canceldelacc"
                  onClick={togglePopup}
                >
                  Cancel
                </button> */}
              </div>
            </div>
          )}
          {showSortPopup && (
            <div className="popup-overlay">
              <div className="popup newsortpop">
                <div className="popup_header">
                  <h2 className="sortbyTitle">Sort By</h2>
                </div>
                <div className="popbodycontent popbodycontentsort">
                  <div className="popup_row sort_pop_row">
                    <p className="sortTitle">Date Modified</p>
                    <div className="rightsortgroup">
                      <p
                        onClick={() =>
                          handleSortButtons("desc", "updated_time")
                        }
                        className={`sortbuttons desc ${
                          sortPattern === "desc" && sortType === "updated_time"
                            ? "sortSelected"
                            : ""
                        }`}
                      >
                        Newest
                      </p>
                      <p
                        onClick={() => handleSortButtons("asc", "updated_time")}
                        className={`sortbuttons asc ${
                          sortPattern === "asc" && sortType === "updated_time"
                            ? "sortSelected"
                            : ""
                        }`}
                      >
                        Oldest
                      </p>
                    </div>
                  </div>
                  <div className="popup_row sort_pop_row">
                    <p className="sortTitle">Design</p>
                    <div className="rightsortgroup">
                      <p
                        onClick={() => handleSortButtons("asc", "design")}
                        className={`sortbuttons asc ${
                          sortPattern === "asc" && sortType === "design"
                            ? "sortSelected"
                            : ""
                        }`}
                      >
                        <AiOutlineSortAscending />
                      </p>
                      <p
                        onClick={() => handleSortButtons("desc", "design")}
                        className={`sortbuttons desc ${
                          sortPattern === "desc" && sortType === "design"
                            ? "sortSelected"
                            : ""
                        }`}
                      >
                        <AiOutlineSortDescending />
                      </p>
                    </div>
                  </div>
                  <div className="popup_row sort_pop_row">
                    <p className="sortTitle">Artist</p>
                    <div className="rightsortgroup">
                      <p
                        onClick={() => handleSortButtons("asc", "artist")}
                        className={`sortbuttons asc ${
                          sortPattern === "asc" && sortType === "artist"
                            ? "sortSelected"
                            : ""
                        }`}
                      >
                        <AiOutlineSortAscending />
                      </p>
                      <p
                        onClick={() => handleSortButtons("desc", "artist")}
                        className={`sortbuttons desc ${
                          sortPattern === "desc" && sortType === "artist"
                            ? "sortSelected"
                            : ""
                        }`}
                      >
                        <AiOutlineSortDescending />
                      </p>
                    </div>
                  </div>
                  <div className="popup_row sort_pop_row">
                    <p className="sortTitle">Brand</p>
                    <div className="rightsortgroup">
                      <p
                        onClick={() => handleSortButtons("asc", "brand")}
                        className={`sortbuttons asc ${
                          sortPattern === "asc" && sortType === "brand"
                            ? "sortSelected"
                            : ""
                        }`}
                      >
                        <AiOutlineSortAscending />
                      </p>
                      <p
                        onClick={() => handleSortButtons("desc", "brand")}
                        className={`sortbuttons desc ${
                          sortPattern === "desc" && sortType === "brand"
                            ? "sortSelected"
                            : ""
                        }`}
                      >
                        <AiOutlineSortDescending />
                      </p>
                    </div>
                  </div>
                  <div className="popup_row sort_pop_row lastrow">
                    <p className="sortTitle">Diamond Type</p>
                    <div className="rightsortgroup">
                      <p
                        onClick={() => handleDiamondType("square")}
                        className={`sortbuttons asc ${
                          diamondTypeSort === "square" ? "sortSelected" : ""
                        }`}
                      >
                        Square
                      </p>
                      <p
                        onClick={() => handleDiamondType("round")}
                        className={`sortbuttons desc ${
                          diamondTypeSort === "round" ? "sortSelected" : ""
                        }`}
                      >
                        Round
                      </p>
                    </div>
                  </div>
                  <button className="delete-button" onClick={handleSort}>
                    Sort
                  </button>
                  {/* <button className="cancel-button" onClick={togglePopup}>
                    Cancel
                  </button> */}
                </div>
              </div>
            </div>
          )}
          {showImportPopUp && (
            <div className="popup-overlay">
              <div
                style={{ maxWidth: "700px !important" }}
                className="popup newsortpop newimportpopup"
              >
                <div
                  className="popup_header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h2 style={{ marginLeft: "180px" }} className="sortbyTitle">
                    Import Dreamer Purchased Kits
                  </h2>
                  <span
                    onClick={() => setShowImportPopUp(false)} // Or your close handler
                    style={{
                      cursor: "pointer",
                      fontSize: "30px",
                      color: "#000000",
                      fontWeight: "bold",
                      marginLeft: "auto",
                    }}
                  >
                    &times;
                  </span>
                </div>
                {internalLoading ? (
                  <div
                    style={{
                      height: "300px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    className="popbodycontent popbodycontentsort"
                  >
                    <div className="loader-container">
                      <Bars color="#552F83" height="40" width="40" />
                    </div>
                    Please Wait....
                  </div>
                ) : (
                  <div className="popbodycontent popbodycontentsort">
                    <div
                      style={{ width: "initial !important" }}
                      className="search-container"
                    >
                      <PiMagnifyingGlassLight
                        className="searchIcon"
                        onClick={() => searchDreamerProducts()}
                      />
                      <input
                        onChange={(e) => {
                          setSearchDreamer(e.target.value);
                          // Optionally do live search
                          // OR you can debounce this too
                        }}
                        type="text"
                        value={searchDreamer}
                        className="searchBox"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") searchDreamerProducts();
                        }}
                        placeholder="Search"
                      ></input>
                    </div>
                    <div className="selectionImport">
                      <p>Select Kits</p>
                      <p
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          cursor: "pointer",
                          color: "#552F83",
                        }}
                      >
                        Select All
                        <input
                          type="checkbox"
                          onChange={selectAllImported}
                          checked={selectAllChecked}
                          disabled={filteredDreamerData.length < 1}
                          style={{
                            cursor:
                              filteredDreamerData.length < 1
                                ? "not-allowed"
                                : "pointer",
                            width: "20px",
                            height: "20px",
                          }}
                        />
                      </p>
                    </div>
                    <div className="internalImportSection">
                      {filteredDreamerData.length > 0 ? (
                        filteredDreamerData.map((project, index) => (
                          <div
                            key={index}
                            className="popup_row sort_pop_row importPopRow"
                          >
                            <div className="leftProjectGroup">
                              <div className="imageBox">
                                <img
                                  style={{
                                    width: "50px",
                                    padding: "5px",
                                    backgroundColor: "#efdeff",
                                    height: "50px",
                                    borderRadius: "5px",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                  }}
                                  src={
                                    project.image || imagePaths.dreamer_logo_new
                                  }
                                  alt="Dreamer Logo"
                                />
                              </div>
                              <div className="rightTextProject">
                                <p className="projectText projectMainOuterTitle">
                                  {project.design || "---"}
                                </p>
                                <p className="projectText projectInnerTitle">
                                  {project.artist
                                    ? `© ${project.artist}`
                                    : "---"}
                                </p>
                                <p className="projectText projectInnerTitle">
                                  {project.brand ? `© ${project.brand}` : "---"}
                                </p>
                              </div>
                            </div>

                            <div className="rightProjectGroup">
                              <p>
                                <input
                                  type="checkbox"
                                  checked={selectedProjects.some(
                                    (p) =>
                                      p.product_id === project.product_id &&
                                      p.variant_id === project.variant_id
                                  )}
                                  onChange={(e) =>
                                    selectProjectForImport(e, project)
                                  }
                                  style={{
                                    cursor: "pointer",
                                    width: "20px",
                                    height: "20px",
                                  }}
                                />
                              </p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p style={{ padding: "10px", textAlign: "center" }}>
                          No projects found
                        </p>
                      )}
                    </div>

                    <button
                      className="delete-button"
                      onClick={importProjects}
                      disabled={importLoading}
                    >
                      {importLoading ? (
                        "Importing..."
                      ) : (
                        <>
                          <BiImport /> Import
                        </>
                      )}
                    </button>

                    {/* <button className="cancel-button" onClick={togglePopup}>
                    Cancel
                  </button> */}
                  </div>
                )}
              </div>
            </div>
          )}
          {showPopup && (
            <div className="popup-overlay">
              <div className="popup">
                {/* <h2>Do you want to upda</h2> */}
                <p>Are you sure you want to set this project as completed?</p>
                {/* <div className="warning">
                  <strong>
                    <IoIosWarning /> Warning
                  </strong>
                  <p>
                    By deleting the account you will lose all your projects data
                    and media.
                  </p>
                </div> */}
                <button className="delete-button" onClick={updateProjectStatus}>
                  Yes
                </button>
                <button className="cancel-button" onClick={togglePopup}>
                  Cancel
                </button>
              </div>
            </div>
          )}

          <div className="outer_banner">
            <div className="mid_banner" style={{ position: "initial" }}>
              <div className="left_mid_container">
                <h4>Projects</h4>
              </div>
              <div className="right_mid_container">
                <div className="inner_right_group">
                  <div className="search-container">
                    <PiMagnifyingGlassLight
                      className="searchIcon"
                      onClick={() => searchProducts()}
                    />
                    <input
                      onClick={() => searchProducts()}
                      type="text"
                      readOnly
                      value={search}
                      className="searchBox"
                      onChange={handleChange}
                      placeholder="Search"
                    ></input>
                  </div>
                  {/* <input type='text' className='searchBox' placeholder='Search'></input> */}
                  <span className="sortHome" onClick={toggleSortPopup}>
                    Sort by <BiSort />
                  </span>
                  {canUseShopify === "true" && (
                    <span className="sortHome" onClick={toggleImportPopup}>
                      Import&nbsp;
                      <BiImport />
                    </span>
                  )}
                  <span onClick={addProject}>New Project +</span>
                </div>
              </div>
            </div>
            <div className="filters">
              {selectedFilters.sort && (
                <div className="sortType">
                  {selectedFilters.type === "asc" && <AiOutlineSortAscending />}
                  {selectedFilters.type === "desc" && (
                    <AiOutlineSortDescending />
                  )}
                  <>
                    {sortTypeKey}
                    <AiOutlineClose
                      onClick={() => clearFilter("sort")}
                      style={{ marginLeft: "5px", cursor: "pointer" }}
                    />
                  </>
                </div>
              )}
              {selectedFilters.diamondType && (
                <div className="diamondType sortType">
                  {selectedFilters.diamondType}{" "}
                  <AiOutlineClose
                    onClick={() => clearFilter("diamondType")}
                    style={{ marginLeft: "5px", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="inner_container">
            <div className="table_container" style={{ marginTop: "5px" }}>
              <div className="table_inner_card">
                <div className="button_group_dashboard ">
                  <span
                    className={type === "completed" ? "activespan" : ""}
                    onClick={() => handleTypeClick("completed")}
                  >
                    Completed
                  </span>
                  <span
                    className={type === "ongoing" ? "activespan" : ""}
                    onClick={() => handleTypeClick("ongoing")}
                  >
                    In-Progress
                  </span>
                  <span
                    className={type === "not_started" ? "activespan" : ""}
                    onClick={() => handleTypeClick("not_started")}
                  >
                    Not Started
                  </span>
                </div>
                {projectData.projects.length > 0 ? (
                  <table className="projectsTable">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Design</th>
                        <th>Artist</th>
                        <th>Brand</th>
                        <th>Logged time</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {projectData.projects.length > 0 ? (
                        projectData.projects.map((project) => (
                          <tr
                            key={project._id}
                            onClick={() => openProjectDetail(project._id)}
                          >
                            <td>
                              <img
                                alt="project_image"
                                className="table_image"
                                src={project.image[0]}
                              ></img>
                            </td>
                            <td className="design_text">{project.design}</td>
                            <td>© {project.artist}</td>
                            <td>{project.brand}</td>
                            <td className="timesection">
                              {" "}
                              {project && (
                                <>
                                  {project.timer_status === "started" ? (
                                    <>
                                      <FaRegCirclePause
                                        className="timer_duration"
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          handleTimer("stop", project._id);
                                        }}
                                      />
                                      {convertSecondsToHoursLive(liveTimer)}
                                    </>
                                  ) : (
                                    <>
                                      <FaRegCirclePlay
                                        className="timer_duration"
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          handleStartTimer(
                                            "start",
                                            project._id
                                          );
                                          // handleTimer("start", project._id);
                                        }}
                                      />
                                      {convertSecondsToHours(
                                        project.totalDuration
                                      )}
                                    </>
                                  )}
                                </>
                              )}{" "}
                            </td>
                            <td>
                              <span
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handleUpdateStatus(
                                    project._id,
                                    project.project_status
                                  );
                                }}
                                className={project.project_status}
                              >
                                {" "}
                                <LuRadar />{" "}
                                {convertText(project.project_status)}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <div className="no_project">
                          {showUI && (
                            <div>
                              <p>
                                Currently, you don't have any projects in
                                progress.
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </tbody>
                  </table>
                ) : (
                  // {showUI ? &&(
                  <div className="no_project">
                    {showUI && (
                      <div>
                        <p>{noUItext}</p>
                      </div>
                    )}
                  </div>
                  // )}
                  // </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectScreen;
